import { rovingTabs } from '@/utils/roving-tabs';
import { createSlider, reducedMotionQuery, syncSlides } from '@/utils/slider';

function startGallery(gallery) {
    const viewport = gallery.querySelector('[data-property-rooms-slider]');
    if (!viewport || viewport.swiper) {
        return;
    }

    gallery.classList.add('is-ready');

    const swiper = createSlider(viewport, {
        prev: gallery.querySelector('[data-property-rooms-slide-prev]'),
        next: gallery.querySelector('[data-property-rooms-slide-next]'),
        keyboard: false,
        slidesPerView: 1,
        loop: true,
    });

    const reveal = () => syncSlides(viewport.querySelectorAll('[data-property-rooms-slide]'));
    swiper.on('slideChangeTransitionEnd', reveal);
    reveal();
}

document.querySelectorAll('[data-property-rooms]').forEach((root) => {
    const list = root.querySelector('[data-property-rooms-tabs]');
    const tabs = [...root.querySelectorAll('[data-property-rooms-tab]')];
    const panels = [...root.querySelectorAll('[data-property-rooms-panel]')];
    const galleries = [...root.querySelectorAll('[data-property-rooms-gallery]')];
    const prev = root.querySelector('[data-property-rooms-prev]');
    const next = root.querySelector('[data-property-rooms-next]');
    let current = 0;

    const select = (index) => {
        if (index < 0 || index >= tabs.length) {
            return;
        }
        current = index;

        tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
            tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach((panel, i) => {
            panel.inert = i !== index;
        });
        galleries.forEach((gallery, i) => {
            gallery.hidden = i !== index;
        });
        if (list && list.scrollWidth > list.clientWidth) {
            const tab = tabs[index];
            list.scrollTo({
                left: tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2,
                behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
            });
        }
        prev?.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
        next?.setAttribute('aria-disabled', index === tabs.length - 1 ? 'true' : 'false');

        if (galleries[index]) {
            startGallery(galleries[index]);
        }
    };

    rovingTabs(tabs, select);

    prev?.addEventListener('click', () => {
        select(current - 1);
    });

    next?.addEventListener('click', () => {
        select(current + 1);
    });

    if (galleries[0]) {
        startGallery(galleries[0]);
    }
});
